import contentfulClient from './index';

async function getEntries({ queryKey }: any) {
  const response = await contentfulClient
    .getEntries({
      content_type: queryKey[0],
      include: 10
    })
    .catch(err => err);

  if(response.status) {
    throw new Error(response.message);
  }

  return response;
}

export default getEntries;